import moment from 'moment';

export const formatAppointmentTime = appointment => {
  if (!appointment.start_time) return null;
  return moment(appointment.start_time).format('h:mm a');
};

export const formatAppointmentAddress = appointment => {
  if (!appointment?.address_line_1) return '';
  let address = appointment.address_line_1;
  if (appointment.address_line_2) address += ', ' + appointment.address_line_2;
  if (appointment.address_city) address += ', ' + appointment.address_city;
  if (appointment.address_state) address += ', ' + appointment.address_state;
  if (appointment.address_zip) address += ' ' + appointment.address_zip;
  return address;
};
